import React from 'react'
import Shimmer from './Shimmer'
import "./StoreImgSkeleton.scss"
import { FaImage } from "react-icons/fa"
const StoreImgSkeleton = () => {
    return (
        <div className="Storepush">
            <div className='StoreImageSkeleton_Container'>
                <div className="StoreImageSkeleton_wrapper">
                    <div className="StoreImageSkeleton_Img"> <FaImage /></div>
                    <div className="StoreImageSkeleton_heading"></div>
                    <div className="StoreImageSkeleton_price"></div>
                    <div className="StoreImageSkeletonDown">
                        <div className="StoreImageSkeleton_Button"></div>
                        <div className="right-skelet">
                            <div className="StoreImageSmall-Icons"></div>
                            <div className="StoreImageSmall-Icons"></div>
                        </div>
                    </div>
                </div>

                <Shimmer />
            </div>
        </div>

    )
}

export default StoreImgSkeleton
